import React from 'react';
import { View, StatusBar, Platform } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

const QStatusBar = ({ backgroundColor, barStyle = 'dark-content' }) => {
  const insets = useSafeAreaInsets();
  return (
    <View style={{ height: insets.top, backgroundColor }}>
      <StatusBar
        animated={true}
        backgroundColor={backgroundColor}
        barStyle={barStyle}
        translucent={Platform.OS === 'ios' ? true : false}
      />
    </View>
  );
};
export default QStatusBar;
